import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from './_layout/app.layout.component';
import { CtAuthenticationGuard } from '@ctsolution/ct-authentication';
import { SellerGuard } from './_core/guard/seller-guard';
import { RedirectGuard } from './_core/guard/redirect.guard';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                {
                    path: '',
                    component: AppLayoutComponent,
                    children: [
                        // Redirect dalla root alla dashboard
                        {
                            path: '',
                            pathMatch: 'full',
                            redirectTo: 'dashboard'
                        },
                        // Dashboard - accessibile senza autenticazione
                        {
                            path: 'dashboard',
                            loadChildren: () =>
                                import(
                                    './pages/dashboard/dashboard.module'
                                ).then((m) => m.DashboardModule),
                        },
                        // FAQ - accessibile senza autenticazione
                        {
                            path: 'faq',
                            loadChildren: () =>
                                import(
                                    './pages/faq/faq.module'
                                ).then((m) => m.FaqModule),
                        },
                        // Authentication routes (login, register, etc.)
                        {
                            path: 'auth',
                            loadChildren: () =>
                                import(
                                    './pages/authentication/authentication.module'
                                ).then((m) => m.AuthenticationModule),
                        },
                        // Routes protette - richiedono autenticazione e seller status
                        {
                            path: 'auction',
                            loadChildren: () =>
                                import(
                                    './pages/auction/auction.module'
                                ).then((m) => m.AuctionModule),
                            canActivate: [CtAuthenticationGuard, SellerGuard]
                        },
                        {
                            path: 'my-purchases',
                            loadChildren: () =>
                                import(
                                    './pages/my-purchases/my-purchases.module'
                                ).then((m) => m.MyPurchasesModule),
                            canActivate: [CtAuthenticationGuard, SellerGuard]
                        },
                        // Nuove routes per aste vinte e vendite concluse
                        {
                            path: 'my-wins',
                            loadChildren: () =>
                                import(
                                    './pages/my-wins/my-wins.module'
                                ).then((m) => m.MyWinsModule),
                            canActivate: [CtAuthenticationGuard]
                        },
                        {
                            path: 'my-sales',
                            loadChildren: () =>
                                import(
                                    './pages/my-sales/my-sales.module'
                                ).then((m) => m.MySalesModule),
                            canActivate: [CtAuthenticationGuard, SellerGuard]
                        },
                        // Routes protette - richiedono solo autenticazione
                        {
                            path: 'profile',
                            loadChildren: () =>
                                import(
                                    './pages/profile/profile.module'
                                ).then((m) => m.ProfileModule),
                            canActivate: [CtAuthenticationGuard]
                        },
                        {
                            path: 'become-seller',
                            loadChildren: () =>
                                import(
                                    './pages/become-seller/become-seller.module'
                                ).then((m) => m.BecomeSellerModule),
                            canActivate: [CtAuthenticationGuard]
                        },
                    ]
                },
                // Fallback con redirect condizionale
                {
                    path: '**',
                    canActivate: [RedirectGuard],
                    children: []
                },
            ],
            {
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled',
                onSameUrlNavigation: 'reload',
            }
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
